import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=c6a9e5e4&scoped=true"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"
import style0 from "./Splash.vue?vue&type=style&index=0&id=c6a9e5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a9e5e4",
  null
  
)

export default component.exports